/**
 * Base messages es-DO — locale canonico V1.
 * Otros locales (es-MX, es-CO, en-US) extienden este con overrides.
 */
export const esDO = {
  // Common
  'common.save': 'Guardar',
  'common.cancel': 'Cancelar',
  'common.delete': 'Eliminar',
  'common.edit': 'Editar',
  'common.create': 'Crear',
  'common.search': 'Buscar',
  'common.loading': 'Cargando…',
  'common.confirm': 'Confirmar',
  'common.close': 'Cerrar',
  'common.next': 'Siguiente',
  'common.previous': 'Anterior',
  'common.yes': 'Sí',
  'common.no': 'No',

  // Navigation
  'nav.dashboard': 'Dashboard',
  'nav.properties': 'Propiedades',
  'nav.leads': 'Leads',
  'nav.crm': 'CRM',
  'nav.marketing': 'Marketing',
  'nav.reports': 'Reportes',
  'nav.settings': 'Configuración',
  'nav.billing': 'Facturación',
  'nav.logout': 'Cerrar sesión',

  // Properties
  'properties.title': 'Propiedades',
  'properties.create': 'Crear propiedad',
  'properties.type.apartment': 'Apartamento',
  'properties.type.house': 'Casa',
  'properties.type.land': 'Terreno',
  'properties.type.commercial': 'Comercial',
  'properties.type.vacation_rental': 'Alquiler vacacional',

  // Leads
  'leads.title': 'Leads',
  'leads.stage.new': 'Nuevo',
  'leads.stage.contacted': 'Contactado',
  'leads.stage.qualified': 'Calificado',
  'leads.stage.negotiation': 'Negociación',
  'leads.stage.closed_won': 'Ganado',
  'leads.stage.closed_lost': 'Perdido',

  // Billing
  'billing.subscription': 'Suscripción',
  'billing.plan': 'Plan',
  'billing.addons': 'Addons',
  'billing.invoices': 'Facturas',
  'billing.upgrade': 'Subir de plan',
  'billing.cancel': 'Cancelar suscripción',

  // Errors
  'error.unknown': 'Ocurrió un error inesperado',
  'error.network': 'Error de red. Verifica tu conexión.',
  'error.unauthorized': 'No autorizado',
  'error.forbidden': 'No tienes permisos para esta acción',
  'error.not_found': 'No encontrado',

  // Success
  'success.saved': 'Guardado correctamente',
  'success.deleted': 'Eliminado correctamente',
  'success.created': 'Creado correctamente',
};

export type MessageKey = keyof typeof esDO;
